import {createSignal} from '@pexip/signal';

export const recentsSignal = createSignal<void>();
export const favoritesSignal = createSignal<void>();
export const favoritesOrderSignal = createSignal<void>();
export const openFavoritesLimitReachedModalSignal = createSignal<void>();
